import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import "@selectize/selectize";

import Rails from "@rails/ujs";
import { Turbo } from "@hotwired/turbo-rails"
import "bootstrap";
import "./pages/common";
import "./pages/impersonate";
import "./pages/internal_user";

Turbo.session.drive = false;
Rails.start()
